/**
 * Created by JasonChou on 17/6/19.
 */
import React, {Component} from 'react'
import Text from '../Text'

export default class LoadMore extends Component {
    render() {

        let {loading, hasMore, ...other} = this.props;

        let text = '';

        if (loading)
            text = '加载中...';
        else if (hasMore) {
            text = '点击加载更多';
        } else {
            text = '没有更多了';
        }

        return <Text {...other} center style={{color: '#aaa', width: '100%', marginTop: 10, marginBottom: 10}}>
            {text}
        </Text>
    }
}


// WEBPACK FOOTER //
// ./src/components/list_screen/LoadMore.js